"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activeOrNaturalDetails = activeOrNaturalDetails;
const appendURLs_js_1 = require("./utils/appendURLs.js");
const fetchJSON_js_1 = require("./utils/fetchJSON.js");
const includeDBRefs_js_1 = require("./utils/includeDBRefs.js");
const normalizeActivities_js_1 = require("./utils/normalizeActivities.js");
/**
 * Search for a specific natural or active compound using its ID
 * @param {object} [options={}]
 * @param {string} [options.fields='_id,data'] - List of fields to retrieve
 * @param {string} [options.route='activesOrNaturals/v1/id'] - URL of the webservice
 * @param {string} [options.baseURL='https://octochemdb.cheminfo.org/'] - URL of the webservice
 */
async function activeOrNaturalDetails(id, options = {}) {
    const { route = 'activesOrNaturals/v1/id', baseURL = 'https://octochemdb.cheminfo.org/', fields = '_id,data', } = options;
    const activeOrNatural = await fetchActiveOrNatural(id, {
        url: new URL(route, baseURL).toString(),
        fields,
    });
    await (0, includeDBRefs_js_1.includeDBRefs)(activeOrNatural, { baseURL });
    ensureArray(activeOrNatural);
    (0, appendURLs_js_1.appendURLs)(activeOrNatural);
    (0, normalizeActivities_js_1.normalizeActivities)(activeOrNatural);
    return activeOrNatural;
}
function ensureArray(activeOrNatural) {
    if (!activeOrNatural.data.activities) {
        activeOrNatural.data.activities = [];
    }
    if (!activeOrNatural.data.pubmeds) {
        activeOrNatural.data.pubmeds = [];
    }
    if (!activeOrNatural.data.patents) {
        activeOrNatural.data.patents = [];
    }
    if (!activeOrNatural.data.taxonomies) {
        activeOrNatural.data.taxonomies = [];
    }
}
async function fetchActiveOrNatural(id, options) {
    const { fields, url } = options;
    const searchParams = {};
    searchParams.id = id;
    if (fields) {
        searchParams.fields = fields;
    }
    const results = await (0, fetchJSON_js_1.fetchJSON)(url, searchParams);
    return results.data;
}
//# sourceMappingURL=activeOrNaturalDetails.js.map